'use client';;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:native-teams-frontend":true});}catch(e){}}();

import { RootLoading } from '@workspace/ui/components/custom/loading';
import { useRouter } from 'next/navigation';
import { useEffect, useRef } from 'react';
import { clearAuthCookies, refreshToken } from '@/actions/mixed/auth';
import { useAuthStore } from '@/stores/authStore';

export default function RefreshAccessToken() {
  const setAccessToken = useAuthStore((s) => s.setAccessToken);
  const setIsAuthenticated = useAuthStore((s) => s.setAuthenticated);
  const setIsLoading = useAuthStore((s) => s.setIsLoading);
  const hasRefreshed = useRef(false);

  const router = useRouter();

  useEffect(() => {
    // Prevent multiple refresh attempts
    if (hasRefreshed.current) {
      return;
    }

    hasRefreshed.current = true;

    const refreshTokenAsync = async () => {
      try {
        const { success, isProcessing } = await refreshToken();

        if (!success) {
          if (isProcessing) {
            window.setTimeout(() => window.location.reload(), 1_000);
            return;
          }

          setAccessToken(null);
          setIsAuthenticated(false);

          void clearAuthCookies().catch(() => undefined);

          window.location.href = process.env.NEXT_PUBLIC_FE_URL_AUTH!;
        } else {
          router.refresh();
        }
      } catch {
        setAccessToken(null);
        setIsAuthenticated(false);

        void clearAuthCookies().catch(() => undefined);

        window.location.href = process.env.NEXT_PUBLIC_FE_URL_AUTH!;
      } finally {
        setIsLoading(false);
      }
    };

    refreshTokenAsync();
  });

  return <RootLoading />;
}
